// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Carousel_carousel-container__WHR-6 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}
.Carousel_carousel-container__WHR-6 .Carousel_large-image__\\+wdoe {
  width: 100%;
}
.Carousel_carousel-container__WHR-6 .Carousel_large-image__\\+wdoe .Carousel_main-image__F6jx3 {
  width: 100%;
  height: 400px;
  object-fit: cover;
  border-radius: 8px;
}
.Carousel_carousel-container__WHR-6 .Carousel_large-image__\\+wdoe .Carousel_fallback-image__Ack4X {
  border-radius: 8px 8px 0px 0px;
  width: 100%;
  height: 400px;
  object-fit: cover;
  object-position: 100% 40%;
  border-radius: 8px;
  background-color: #f2f2f2;
  display: flex;
  justify-content: center;
  align-items: center;
}

.Carousel_carousel__13OqC {
  margin: 20px 0px;
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.Carousel_tabs__neGAE {
  width: 100%;
}

.Carousel_carousel-images-container__JnaUf {
  width: 80%;
}
.Carousel_carousel-images-container__JnaUf .Carousel_carousel-images__KKmb1 {
  list-style: none;
  display: flex;
  justify-content: space-evenly;
}
.Carousel_carousel-images-container__JnaUf ul {
  padding: 0;
  margin: 0;
}
.Carousel_carousel-images-container__JnaUf ul li Button {
  padding: 0;
  margin: 0;
}
.Carousel_carousel-images-container__JnaUf ul .Carousel_slide__BCF6u img {
  width: 100%;
  max-width: 80px;
  border-radius: 4px;
}
.Carousel_carousel-images-container__JnaUf ul .Carousel_slide-loading__C4ZkV {
  height: 60px;
  width: 60px;
}
.Carousel_carousel-images-container__JnaUf ul .Carousel_slide-circle-loading__s9Cv2 {
  height: 30px;
  width: 30px;
  border-radius: 30px;
  margin-top: 10px;
}

.Carousel_arrow-button__RCV0O {
  min-width: 37px;
}
.Carousel_arrow-button__RCV0O Button {
  padding: 10px;
  font-size: 16px;
}
.Carousel_arrow-button__RCV0O .Carousel_icon__-p16P {
  font-size: 16px;
}

.Carousel_loading-image__kPXKZ {
  width: 100%;
  height: 400px;
}

.Carousel_loading__F3bW4 {
  background: linear-gradient(-45deg, #ffffff, rgb(219, 214, 214));
  background-size: 400% 400%;
  animation: Carousel_gradient__WY-F1 4s ease infinite;
}

@keyframes Carousel_gradient__WY-F1 {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/common/Carousel/Carousel.module.scss","webpack://./src/styles/_colors.scss","webpack://./src/styles/_typography.scss"],"names":[],"mappings":"AAGA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,8BAAA;AAFF;AAIE;EACE,WAAA;AAFJ;AAII;EACE,WAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;AAFN;AAKI;EACE,8BAAA;EACA,WAAA;EACA,aAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBCfgB;EDgBhB,aAAA;EACA,uBAAA;EACA,mBAAA;AAHN;;AAQA;EACE,gBAAA;EACA,WAAA;EACA,aAAA;EACA,6BAAA;EACA,mBAAA;AALF;;AAQA;EACE,WAAA;AALF;;AAQA;EACE,UAAA;AALF;AAOE;EACE,gBAAA;EACA,aAAA;EACA,6BAAA;AALJ;AAQE;EACE,UAAA;EACA,SAAA;AANJ;AASM;EACE,UAAA;EACA,SAAA;AAPR;AAWI;EACE,WAAA;EACA,eAAA;EACA,kBAAA;AATN;AAYI;EACE,YAAA;EACA,WAAA;AAVN;AAaI;EACE,YAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;AAXN;;AAgBA;EACE,eAAA;AAbF;AAeE;EACE,aAAA;EACA,eEzFK;AF4ET;AAgBE;EACE,eE7FK;AF+ET;;AAkBA;EACE,WAAA;EACA,aAAA;AAfF;;AAkBA;EACE,gEAAA;EACA,0BAAA;EACA,oDAAA;AAfF;;AAkBA;EACE;IACE,2BAAA;EAfF;EAiBA;IACE,6BAAA;EAfF;EAiBA;IACE,2BAAA;EAfF;AACF","sourcesContent":["@use \"styles/typography\";\n@use \"styles/colors\";\n\n.carousel-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n\n  .large-image {\n    width: 100%;\n\n    .main-image {\n      width: 100%;\n      height: 400px;\n      object-fit: cover;\n      border-radius: 8px;\n    }\n\n    .fallback-image {\n      border-radius: 8px 8px 0px 0px;\n      width: 100%;\n      height: 400px;\n      object-fit: cover;\n      object-position: 100% 40%;\n      border-radius: 8px;\n      background-color: colors.$color-background-02;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n    }\n  }\n}\n\n.carousel {\n  margin: 20px 0px;\n  width: 100%;\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n}\n\n.tabs {\n  width: 100%;\n}\n\n.carousel-images-container {\n  width: 80%;\n\n  .carousel-images {\n    list-style: none;\n    display: flex;\n    justify-content: space-evenly;\n  }\n\n  ul {\n    padding: 0;\n    margin: 0;\n\n    li {\n      Button {\n        padding: 0;\n        margin: 0;\n      }\n    }\n\n    .slide img {\n      width: 100%;\n      max-width: 80px;\n      border-radius: 4px;\n    }\n\n    .slide-loading {\n      height: 60px;\n      width: 60px;\n    }\n\n    .slide-circle-loading {\n      height: 30px;\n      width: 30px;\n      border-radius: 30px;\n      margin-top: 10px;\n    }\n  }\n}\n\n.arrow-button {\n  min-width: 37px;\n\n  Button {\n    padding: 10px;\n    font-size: typography.$body-l;\n  }\n\n  .icon {\n    font-size: typography.$body-l;\n  }\n}\n\n.loading-image {\n  width: 100%;\n  height: 400px;\n}\n\n.loading {\n  background: linear-gradient(-45deg, #ffffff, rgb(219, 214, 214));\n  background-size: 400% 400%;\n  animation: gradient 4s ease infinite;\n}\n\n@keyframes gradient {\n  0% {\n    background-position: 0% 50%;\n  }\n  50% {\n    background-position: 100% 50%;\n  }\n  100% {\n    background-position: 0% 50%;\n  }\n}\n","$neutral: #333333;\n$neutral-700: #252525;\n$accent: #054ab0;\n$primary: #ff6b00;\n$primary-hover: #c75004;\n$secondary: #1f1f1f;\n$secondary-hover: #393939;\n$default: #666666;\n$light: #616c7a;\n$white: #ffffff;\n$light-blue: #ebf3ff;\n$color-background-02: #f2f2f2;\n$color-background-text: #fbfbfb;\n$color-text-02: #333333;\n$color-text-disabled: #808080;\n$color-button-disabled: #e9e9e9;\n$color-semantic-primary: #e6e6e6;\n$color-success-active: #008863;\n$color-success-disable: #32d2a7;\n$color-error-active: #a63631;\n$color-error-disable: #ff9590;\n$error: #c9423c;\n$text-link: #0058e1;\n$text-link-hover: #003b9c;\n$neutral-200: #696969;\n$error-200: #d73a3d;\n$warning-200: #ffb93c;\n$info-200: #1175c9;\n$success-300: #4ba564;\n$neutral-400: #bbbbbb;\n","$body-s: 12px;\n$body-m: 14px;\n$body-l: 16px;\n$header-xs: 18px;\n$header-s: 20px;\n$header-m: 24px;\n$header-l: 34px;\n$bold: bold;\n$semi-bold: 600;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"carousel-container": `Carousel_carousel-container__WHR-6`,
	"large-image": `Carousel_large-image__+wdoe`,
	"main-image": `Carousel_main-image__F6jx3`,
	"fallback-image": `Carousel_fallback-image__Ack4X`,
	"carousel": `Carousel_carousel__13OqC`,
	"tabs": `Carousel_tabs__neGAE`,
	"carousel-images-container": `Carousel_carousel-images-container__JnaUf`,
	"carousel-images": `Carousel_carousel-images__KKmb1`,
	"slide": `Carousel_slide__BCF6u`,
	"slide-loading": `Carousel_slide-loading__C4ZkV`,
	"slide-circle-loading": `Carousel_slide-circle-loading__s9Cv2`,
	"arrow-button": `Carousel_arrow-button__RCV0O`,
	"icon": `Carousel_icon__-p16P`,
	"loading-image": `Carousel_loading-image__kPXKZ`,
	"loading": `Carousel_loading__F3bW4`,
	"gradient": `Carousel_gradient__WY-F1`
};
export default ___CSS_LOADER_EXPORT___;
